<template>
  <section class="section-login">
    <div :class="[$mq.phone ? 'bg-white' : 'bg-gray']">
      <section class="container content-padding">
        <div class="row">
          <div class="col-12 p-0">
            <div class="row">
              <div class="col-sm-8 offset-sm-2 col-xl-6 offset-xl-3 col-12 p-0">
                <div :class="{'card py-3': !$mq.phone}">
                  <div class="text-center" :class="{'card-body': !$mq.phone}">
                    <template v-if="user === null && !registerSuccessFromPage">
                      <div v-if="referralCode">
                        <img :src="referralCodeOwner.picture"
                             class="rounded-circle mb-4"
                             width="80">
                        <h3>{{ $t('message.invite_friends.invite_friends_title', { name: referralCodeOwner.firstname, registerCredits: globalState.configData.register_credits }) }}</h3>
                        <p>
                          {{ $t('message.invite_friends.invite_friends_detail', { name: referralCodeOwner.firstname, credits: globalState.configData.invite_friend_credits, registerCredits: globalState.configData.register_credits }) }}
                        </p>
                        <div class="my-4">
                          <strong>{{ $t('message.invite_friends.sign_up_to_claim_your_credits') }}</strong>
                        </div>
                      </div>
                      <register-form registerFrom="registerPage"/>
                    </template>
                    <template v-else>
                      <div class="text-center">
                        <i class="fal fa-check-circle fa-4x text-success mb-4"></i>
                        <h2>{{$t('message.register.register_success')}}</h2>
                        <div class="mb-4">
                          <label>{{$t('message.register.register_success_detail')}}</label>
                        </div>
                        <router-link tag="button" class="btn btn-primary -cyan" to="/">
                          {{$t('message.register.register_btn_done')}}
                        </router-link>
                        <br><br>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import RegisterForm from '../login/RegisterForm'

  export default {
    name: 'index',

    components: {
      RegisterForm
    },
    data () {
      return {
        name: '',
        referralCode: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        referralCodeOwner: 'referralCode/getReferralCodeOwner',
        user: 'auth/getUser'
      }),
      ...mapState('auth', [
        'registerSuccessFromPage'
      ])
    },
    methods: {
      successRegister (val) {
        this.name = val
      }
    },
    mounted () {
      this.$store.commit('auth/SET_REFERRAL_CODE', null)
      this.$store.commit('auth/SET_REGISTER_SUCCESS_PAGE', false)
      if (this.$route.query.c) {
        this.referralCode = this.$route.query.c
        this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_OWNER', this.referralCode)
        this.$store.commit('auth/SET_REFERRAL_CODE', this.referralCode)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/register/Index.vue